// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GridPageLogic__children--hidden":"cl_a bih_c","GridPageLogic__locations__placesRadius":"cl_b bih_sv"};